export class BalanceResponse {
    constructor(public balanceVisible?: boolean, public amount?: number, public discount?: number, public debtNo?: string, public currencyCode?: string) {}
}
